import { createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import { onGetDeliveryTypes} from '../../../app/services/dataForComboBox/dataForComboBoxService'
import { onGetMyGraduatedInfo } from '../../../app/modules/graduation-system/components/graduates/core/_requests'
import { onCreateCardRequest, onDeleteCardRequest, onGetCardRequest, onGetCardRequests, onUpdateCardRequest } from '../../../app/modules/areas/graduates/card-request/core/_requests'
import { onGetAddressesAllOfTheUser } from '../../../app/modules/profile/addresses/core/_requests'
interface CardRequestState {
  userAddresses: any
  deliveryTypes: any
  graduated: any
  cardRequests : any
  cardRequest : any
  isLoading: boolean
}
const initialState = {
  userAddresses: [],
  deliveryTypes: [],
  cardRequest: null,
  cardRequests: [],
  graduated: null,
  isLoading: true,
} as CardRequestState

export const fetchUserAddresses = createAsyncThunk('cardRequest/fetchUserAddresses', async () => {
  const data: any = await onGetAddressesAllOfTheUser()
  return data.data.result.items
})

export const fetchdeliveryTypes = createAsyncThunk('cardRequest/fetchDeliveryTypes', async () => {
  const data: any = await onGetDeliveryTypes()
  return data.data.result.items
})

export const fetchGraduated = createAsyncThunk('cardRequest/graduated', async () => {
  const data: any = await onGetMyGraduatedInfo()
  return data.data.result
})
export const fetchCardRequests = createAsyncThunk('cardRequest/getCardRequests', async () => {
  const data: any = await onGetCardRequests()
  return data.data.result
})
export const fetchCardRequest = createAsyncThunk('cardRequest/getCardRequest', async (param: any) => {
  const data: any = await onGetCardRequest(param)
  return data.data.result
})
export const createCardRequest = createAsyncThunk('cardRequest/createCardRequest', async (param: any) => {
  const data: any = await onCreateCardRequest(param)
  return data.data.result
})
export const updateCardRequest = createAsyncThunk('cardRequest/updateCardRequest', async (param: any) => {
  const data: any = await onUpdateCardRequest(param)
  return data.data.result
})
export const deleteCardRequest = createAsyncThunk('cardRequest/deleteCardRequest', async (param: any) => {
  const data: any = await onDeleteCardRequest(param)
  return data.data
})
const cardRequestSlice = createSlice({
  name: 'cardRequest',
  initialState,
  reducers: {
    clearAddresses: (state) => {
      state.userAddresses = []
    },
    clearDeliveryTypes: (state) => {
      state.deliveryTypes = []
    },
    clearCardRequests: (state) => {
      state.cardRequests = []
    },
    clearCardRequest: (state) => {
      state.cardRequest = null
    },
    clearGraduated: (state) => {
      state.graduated = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserAddresses.pending, (state: any) => {
      state.isLoading = true
    })

    builder.addCase(fetchUserAddresses.fulfilled, (state: any, action) => {
      state.userAddresses = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchUserAddresses.rejected, (state: any) => {
      state.isLoading = false
    })

    builder.addCase(fetchdeliveryTypes.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchdeliveryTypes.fulfilled, (state: any, action) => {
      state.deliveryTypes = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchdeliveryTypes.rejected, (state: any) => {
      state.isLoading = false
    })

    builder.addCase(fetchGraduated.pending, (state: any) => {
        state.isLoading = true
    })
    builder.addCase(fetchGraduated.fulfilled, (state: any, action) => {
        state.graduated = action.payload
        state.isLoading = false
    })
    builder.addCase(fetchGraduated.rejected, (state: any) => {
        state.isLoading = false
    })
    builder.addCase(fetchCardRequests.pending, (state: any) => {
        state.isLoading = true
    })
    builder.addCase(fetchCardRequests.fulfilled, (state: any, action) => {
        state.cardRequests = action.payload
        state.isLoading = false
    })
    builder.addCase(fetchCardRequests.rejected, (state: any) => {
        state.isLoading = false
    })

    builder.addCase(fetchCardRequest.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchCardRequest.fulfilled, (state: any, action) => {
        state.cardRequest = action.payload
        state.isLoading = false
    })
    builder.addCase(fetchCardRequest.rejected, (state: any) => {
        state.isLoading = false
    })
  },
})

export const {clearAddresses, clearDeliveryTypes, clearCardRequests, clearCardRequest, clearGraduated, activateLoading} = cardRequestSlice.actions

export default cardRequestSlice.reducer
